export default "__VITE_ASSET__8d5f76f2__"